import { useState } from 'react';

import Transition from '@/components/Common/Transition';
import { useModalContext } from '@/components/Modal/Modal';
import { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import ReviewAiTopic from '../CreateTopicModal/AiTopic/ReviewAiTopic';
import type { CandidateItemT } from '../CreateTopicModal/AiTopic/types';
import SuggestionStep from './SuggestionStep';
import { type AISuggestionBaseProps, type AISuggestionTarget, Entity } from './types';

enum STEP {
  SUGGESTION,
  REVIEW,
}

const AISuggestionModal = <T extends AISuggestionTarget>(
  props: AISuggestionBaseProps<T>,
) => {
  const { closeModal } = useModalContext();

  const entityList: Entity[] = [
    Entity.Attributes,
    Entity.Product,
    Entity.Issues,
  ];

  const initState = useState(false);
  const [entity, setEntity] = useState<Entity>(Entity.Attributes);
  const [step, setStep] = useState<STEP>(STEP.SUGGESTION);
  const [selectedItems, setSelectedItems] = useState<CandidateItemT[]>([]);

  return (
    <Transition
      status={step === STEP.REVIEW}
      fallback={
        <SuggestionStep
          {...props}
          entity={entity}
          setEntity={setEntity}
          entityList={entityList}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          onNextClick={() => setStep(STEP.REVIEW)}
          initState={initState}
          closeModal={closeModal}
        />
      }
    >
      <ReviewAiTopic
        {...props}
        type={TOPIC_2_TYPE.AI}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        onBackClick={() => setStep(STEP.SUGGESTION)}
        onSubmitSuccess={closeModal}
        closeModal={closeModal}
      />
    </Transition>
  );
};

export default AISuggestionModal;
